import React, { useContext } from 'react';
import { Row, Col } from "antd";
import { AppContext } from '../../../util/context';
import S3Get from '../../S3Get';
import '../../../pages/Home/Home.css';
import { ActionDetailsData } from './ActionDetailsData';

export const ActionDetails = ({hazardCard, setHazardCard, isRep}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    
    return (
        <>
            <Row
                gutter={[0, 24]}
            >

                <Col
                    xl={{span: 16}}
                    lg={{span: 16}}
                    md={{span: 16}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <ActionDetailsData
                        hazardCard={hazardCard}
                        setHazardCard={setHazardCard}
                        isRep={isRep}
                    />
                    
                    {hazardCard.files && hazardCard.files.length > 0 && <>
                        <Row
                            style={{
                                marginTop: "60px"
                            }}
                        >
                            <StyledDiv className="inputTextLabel"><label style={{marginBottom: "10px", width: "100%", textAlign: "center"}}>Uploads & Attachments</label></StyledDiv>
                            
                        </Row>

                        <Row
                            gutter={[24, 12]}
                            style={{
                                marginTop: "20px"
                            }}
                        >
                            {hazardCard.files && hazardCard.files.length > 0 && hazardCard.files.map((file, index) => {
                                /* const signedUrl = cardSignedUrls.find(url => url.filePath === file)
                                const fileName = signedUrl.filePath.split('public/') */
                                const fileName = file.split('public/')
                                return (
                                    <Col
                                        xl={{span: 6}}
                                        lg={{span: 6}}
                                        md={{span: 12}}
                                        sm={{span: 12}}
                                        xs={{span: 12}}
                                        key={fileName[1] + index}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* <GetFiles
                                            key={`${index}`}
                                            filePath={fileName[1]}
                                            signedUrl={signedUrl.url}
                                        /> */}
                                        <S3Get
                                            key={`${index}`}
                                            image={fileName[1]}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                    </>}
                </Col>
            </Row>
        </>
    )
}
